import Box from "../../components/Box";
import Button from "../../components/Button";
import Text from "../../components/Text";

const points = [
    { icon: "", text: "School owners and directors" },
    { icon: "", text: "New school founders or startups" },
    { icon: "", text: "Principals and coordinators" },
    { icon: "", text: "Anyone planning to grow or modernise their school" },
];

export default function WhoShouldAttend() {

    return (
        <Box
            leftBlock={
                <div className='col-span-2 md:col-span-1 bg-[white] p-7 text-center'>
                    <div>
                        <Text type={"cardTitle"} cName="text-balance text-4xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]" label={"Who Should Attend"} />
                         <Text type="description" cName="mt-2 text-xs text-[#4D4D4D] text-pretty font-medium" label={"This webinar customised and is created exclusively for:"} />
                    </div>
                    <div className="flex md:flex-col justify-center items-center gap-6 mt-8">
                        {points.slice(0,2).map((section, index) => (
                            <div key={"asdasdasdasdasd" + index} className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-blue-600 rounded-full md:hidden" />
                                <Text label={section?.text} cName="text-gray-700 text-sm leading-relaxed" />
                            </div>
                        ))}
                    </div>
                    <div className="flex md:flex-col justify-center items-center gap-6 mt-8">
                        {points.slice(2).map((section, index) => (
                            <div key={"asdasdasd" + index} className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-blue-600 rounded-full md:hidden" />
                                <Text label={section?.text} cName="text-gray-700 text-sm leading-relaxed" />
                            </div>
                        ))}
                    </div>
                    <div className="flex md:flex-col justify-center items-center gap-6 mt-8">
                            <Button label='Activate AI ID Cards' type='gradient' />
                            <Button label="Join Live Webinar" type='outlined' />
                        </div>
                </div>
            }
        />
    );
}